/**
 * @generated SignedSource<<57a2ee7b9527490ab3f9d7656c09a833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetKPITileTrendType = "negative" | "positive" | "semiNegative";
import { FragmentRefs } from "relay-runtime";
export type Tile_kpiTile$data = {
  readonly graph: {
    readonly __typename: "WidgetKPITileGraphBar";
    readonly label: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTileGraphBar" | "Tile_kpiTileGraphGauge" | "Tile_kpiTileGraphRegions" | "Tile_kpiTileGraphSlider">;
  } | null;
  readonly subtitle: string | null;
  readonly title: string;
  readonly trends: ReadonlyArray<{
    readonly change: string;
    readonly compareValue: string | null;
    readonly label: string | null;
    readonly type: WidgetKPITileTrendType;
  }> | null;
  readonly unit: string | null;
  readonly value: string;
  readonly " $fragmentType": "Tile_kpiTile";
};
export type Tile_kpiTile$key = {
  readonly " $data"?: Tile_kpiTile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tile_kpiTile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetKPITileTrend",
      "kind": "LinkedField",
      "name": "trends",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "change",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "compareValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "graph",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Tile_kpiTileGraphBar"
            }
          ],
          "type": "WidgetKPITileGraphBar",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Tile_kpiTileGraphSlider"
            }
          ],
          "type": "WidgetKPITileGraphSlider",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Tile_kpiTileGraphRegions"
            }
          ],
          "type": "WidgetKPITileGraphRegions",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Tile_kpiTileGraphGauge"
            }
          ],
          "type": "WidgetKPITileGraphGauge",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetKPITile",
  "abstractKey": null
};
})();

(node as any).hash = "c6fc89c2baafc8dd34bb129b3f127bbb";

export default node;
